export const popupClickOutside = (selectRef: any, func: any) => {
  const handleClickOutside = (event: MouseEvent) => {
    if (
      selectRef.current &&
      !selectRef.current.contains(event.target as Node)
    ) {
      func();
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
};

export const clickOutside = (selectRef: any, id: string, setShow?: any) => {
  var item: HTMLElement | null = null;

  const handleClickOutside = (event: MouseEvent) => {
    if (
      selectRef.current &&
      !selectRef.current.contains(event.target as Node)
    ) {
      item = document.getElementById(id);
      if (item !== null) {
        item.style.display = "none";
        if (setShow) {
          setShow(false);
        }
      }
    } else {
      item = document.getElementById(id);
      if (item !== null) {
        item.style.display = "flex";
      }
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
};
